<template>
  <Section>
    <template #header>
      <div class="mr-auto">
        <strong style="color:black">This Pro's Services</strong>
      </div>
      <ServicesDialog v-if="isPartner(currentPro) && userIsAdmin && !isDeleted(currentPro)" />
    </template>

    <div class="content-block">
      <template v-for="(service,index) in services">
        <v-chip 
          x-small
          :key="'included-' + index"
          v-if="index<6"
          color="grey lighten-3" 
          class="ml-1 px-2"
          style="border: 1px solid #C0C0C0 !important;"
        >
          {{ service }}
        </v-chip>
        <v-chip
          x-small
          :key="'extra-' + index"
          v-if="index===6"
          outlined
          class="ml-1 px-2"
          style="border: 1px solid #C0C0C0 !important;"
        >
          and {{currentPro.offered_services.length-6}} more...
        </v-chip>
      </template>
    </div>
  </Section>
</template>

<script>
  import { Section } from '@/components/pages'
  import ServicesDialog from '../dialogs/Services.vue'

  import { mapGetters } from 'vuex'
  import proMixin from '../proMixin'

  export default {
    name: 'ProServicesSection',

    mixins: [proMixin],
    
    components: { Section, ServicesDialog, },

    computed: {
      ...mapGetters ('auth', ['userIsAdmin']),
      ...mapGetters('pros', ['currentPro']),

      services() {
        return this.currentPro.offered_services.filter(s => !s.blacklisted).map( s => s.service )
      },
    }
  }
</script>
